export const environment = {
  production: false,
  appVersion: 'v1.0.0',
  BASE_URL: 'http://localhost:2400',
  API_BASE_URL: '/api/user',
  API_AUTH_BASE_URL: '/api/auth',
  API_EMAIL_BASE_URL: '/api/email',
  API_EXTERNAL_BASE_URL: '/api/external',
  API_TRANSACTION_BASE_URL: '/api/transaction',
  API_SETTLEMENT_BASE_URL: '/api/settlement',
  API_PAYMENT_SIMULATOR_BASE_URL: '/api/payment-simulator',
  API_PAYMENT_LINK_BASE_URL: '/api/payment-link',
  API_MERCHANT_BASE_URL: '/api/merchant',
  API_FILE_BASE_URL: '/api/file',
  API_PRODUCT_BASE_URL: '/api/product',
  API_ROLE_BASE_URL: '/api/role',
  API_MENU_BASE_URL: '/api/menu',
  API_NOTIFICATION_BASE_URL: '/api/notification',
  API_NOTIFICATION_SSE_BASE_URL: '/api/que-notification',
  API_IP_INFO_BASE_URL: 'https://ipinfo.io',
  API_COUNTRY_INFO_BASE_URL: 'https://api.first.org/data/v1/countries',
  X_API_KEY: 'api_key_test',
  TURNSTILE_SITE_KEY: '0x4AAAAAAB5mB5Sv4OsdhTIz',
  TIMER_RESEND_EMAIL: 1,
  // TOKEN_IPINFO_IO : '6c632f50-7cad-11ee-afec-6f76cdf41dcf',
  TOKEN_IPINFO_IO: 'c570cf186572e2',
  activateCaptcha: false,
  disabledDevTools: false,
  // Role Id
  SALES_ROLE_ID: '99812636-1085-4sui-chan-66082947767b',
  MS_ROLE_ID: 'd1c4dc0a-bbd0-4abc-9116-a8ff01493e89',
  LEGAL_ROLE_ID: '11f3162e-fce5-41cd-99c8-408f7b71eb57',
  RM_ROLE_ID: '99812636-1085-4c21-bb46-66082947767b',
  SUPER_ADMIN_ROLE_ID: '91c19201-3113-4697-8384-064fc92f1e7f',
  // Menu Id
  PROFILE_AND_ACCOUNT_SETTINGS_MENU_ID: '546a0af5-7489-4f10-9f9b-070d7826733d',
  LOGOUT_MENU_ID: 'b96fde55-127c-4573-ba56-7404ba9fa85f',
  LOGIN_MENU_ID: 'a7f1957e-e9ac-42c5-a5a8-8bffdc0b9517',
  USER_SETTINGS_ID: '',
  // Action Id
  PROFILE_AND_ACCOUNT_SETTINGS_ACTION_ID:
    'f193ba95-11ce-4c2a-b6bc-9c0c0a9af550',
  LOGOUT_ACTION_ID: '3a39325f-78db-4f6a-83a6-f0506e7f2222',
  LOGIN_ACTION_ID: '4a27d3cf-ff47-4b92-8c95-3da2299fefb9',
  CLARITY_PROJECT_ID: 'tpzgb85qel',
};
